<template>
	<component :is="$store.state.auth.role"></component>
</template>

<script>
import Accountant from '../components/profile/EditAccountant'
import Client from '../components/profile/EditClient'
import Author from '../components/profile/EditAuthor'
import Manager from '../components/profile/EditManager'
import Admin from '../components/profile/EditAdmin'

export default {
	name: "EditProfile",
	components: {
		Accountant,
		Client,
		Author,
		Manager,
		Admin
	}
}
</script>

<style scoped>

</style>
